var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-main page-btns" },
    [
      _c("div", { staticClass: "card_top" }, [_c("page-title")], 1),
      _vm._v(" "),
      _c(
        "page-card",
        { staticClass: "no-padding", attrs: { noHead: true } },
        [
          _c(
            "template",
            { slot: "tab" },
            [
              _c(
                "el-tabs",
                {
                  staticClass: "page-tab",
                  on: { "tab-click": _vm.handleClick },
                  model: {
                    value: _vm.active,
                    callback: function ($$v) {
                      _vm.active = $$v
                    },
                    expression: "active",
                  },
                },
                [
                  _c("el-tab-pane", { attrs: { name: "1" } }, [
                    _c(
                      "span",
                      { attrs: { slot: "label" }, slot: "label" },
                      [
                        _c("svg-icon", {
                          attrs: { "icon-class": "tn-mineral" },
                        }),
                        _vm._v("Mineral\n          "),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("el-tab-pane", { attrs: { name: "2" } }, [
                    _c(
                      "span",
                      { attrs: { slot: "label" }, slot: "label" },
                      [
                        _c("svg-icon", {
                          attrs: { "icon-class": "tn-digital" },
                        }),
                        _vm._v("Digital\n          "),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "page-table",
              attrs: { slot: "body" },
              slot: "body",
            },
            [
              _c("div", { staticClass: "spaceBetween search-box" }, [
                _c("span", { staticClass: "search-title" }, [
                  _vm._v("Volume details"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "spaceLeft search-form" },
                  [
                    _c("search-date-time", {
                      ref: "date",
                      attrs: { label: "Date" },
                      on: {
                        valChange: function ($event) {
                          return _vm.valChange($event, "dateTo")
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("search-month", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.active == 1,
                          expression: "active == 1",
                        },
                      ],
                      ref: "datetime",
                      attrs: { label: "Date Time" },
                      on: {
                        valChange: function ($event) {
                          return _vm.valChange($event, "month")
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("search-select", {
                      ref: "type",
                      attrs: { label: "Type", options: _vm.typeList },
                      on: {
                        valChange: function ($event) {
                          return _vm.valChange($event, "type")
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.active == 1,
                          expression: "active == 1",
                        },
                      ],
                      staticStyle: { width: "100%" },
                      attrs: { data: _vm.tableData },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "timestamp",
                          label: "Date",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("time")(row.timestamp, "yyyy-MM-DD")
                                  )
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "companyName",
                          label: "Business Name",
                          align: "center",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "type", label: "Type", align: "center" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "month",
                          label: "Data time",
                          align: "center",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "UWI", label: "UWI", align: "center" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "deviation",
                          label: "Volume deviation ratio",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(row.deviation) +
                                    "\n              "
                                ),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: row.deviation,
                                        expression: "row.deviation",
                                      },
                                    ],
                                  },
                                  [_vm._v("%")]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "Deducted Expenses（Unit）",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [_vm._v(_vm._s(_vm.penaltyCost(row)))]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "produce",
                          label: "Total volume",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.splitK(row.produce))),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "value",
                          label: "Value/$",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.splitK(row.value)) +
                                    "\n            "
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "Result", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                _c("img", {
                                  staticStyle: { width: "1.24rem" },
                                  attrs: {
                                    src: require("../../assets/image/reviewed.jpg"),
                                    alt: "",
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.active == 2,
                          expression: "active == 2",
                        },
                      ],
                      staticStyle: { width: "100%" },
                      attrs: { data: _vm.tableData },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { label: "Date", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("time")(row.timestamp, "yyyy-MM-DD")
                                  )
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "account",
                          label: "Account",
                          align: "center",
                          "show-overflow-tooltip": true,
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "type", label: "Type", align: "center" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "produce",
                          label: "Block Height",
                          align: "center",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "Value/$", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                row.status != 1
                                  ? _c("span", [_vm._v("--")])
                                  : _c("big-number", {
                                      attrs: { number: row.value },
                                    }),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "deviation",
                          label: "Deducted Expenses（UNIT）",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                _c("big-number", {
                                  attrs: { number: row.deviation },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "status",
                          label: "Result",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                row.status == 1
                                  ? _c("img", {
                                      staticStyle: { width: "1.24rem" },
                                      attrs: {
                                        src: require("../../assets/image/passed.png"),
                                        alt: "",
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                row.status == 4
                                  ? _c("img", {
                                      staticStyle: { width: "1.24rem" },
                                      attrs: {
                                        src: require("../../assets/image/notpass.png"),
                                        alt: "",
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                row.status == 2
                                  ? _c("img", {
                                      staticStyle: { width: "1.24rem" },
                                      attrs: {
                                        src: require("../../assets/image/inreview.png"),
                                        alt: "",
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("pagination", {
                    attrs: {
                      total: _vm.total,
                      page: _vm.queryParams.page,
                      limit: _vm.queryParams.pageSize,
                    },
                    on: {
                      "update:page": function ($event) {
                        return _vm.$set(_vm.queryParams, "page", $event)
                      },
                      "update:limit": function ($event) {
                        return _vm.$set(_vm.queryParams, "pageSize", $event)
                      },
                      pagination: function ($event) {
                        return _vm.getDataList()
                      },
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Upload digital assets",
            visible: _vm.open,
            width: "5rem",
          },
          on: {
            "update:visible": function ($event) {
              _vm.open = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: { model: _vm.form, "label-position": "top" },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "Block Height",
                    prop: "value",
                    rules: {
                      required: true,
                      message: "Please imput Block Height",
                    },
                  },
                },
                [
                  _c(
                    "el-input",
                    {
                      attrs: {
                        autocomplete: "off",
                        placeholder: "Please fill in",
                      },
                      model: {
                        value: _vm.form.value,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "value", $$v)
                        },
                        expression: "form.value",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100px" },
                          attrs: { slot: "prepend" },
                          slot: "prepend",
                          model: {
                            value: _vm.form.select,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "select", $$v)
                            },
                            expression: "form.select",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "BTC", value: "BTC" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "ETH", value: "ETH" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "Date",
                    prop: "date",
                    rules: { required: true, message: "Please Pick a Date" },
                  },
                },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "date",
                      placeholder: "Pick a day",
                      format: "yyyy-MM-dd",
                    },
                    model: {
                      value: _vm.form.date,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "date", $$v)
                      },
                      expression: "form.date",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("el-button", { on: { click: _vm.handleCancel } }, [
                _vm._v("No"),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.btnLoading },
                  on: { click: _vm.handleSubmite },
                },
                [_vm._v("Submite")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }